import React, { Component } from 'react';
import { connect } from 'react-redux';
import { filter, indexOf, find } from 'lodash';
import PropTypes from 'prop-types';
import OpportunityTable from '../../../Analysic/components/table/opportunity-table';
import AccountTable from '../../../Dashboard/components/AccountTable';
import { ButtonGroup, Button } from 'react-bootstrap';
import { 
  getProgressStats,
} from '../../../Dashboard/DashboardReducer';
import NumberDisplay from '../../../../components/number-display';
import Counter from '../../../../components/counter';
import ProgressSummary from '../progress-summary';


function getType(data) {
  return find(ProgressSummary.STATS, { key: data.category });
}

function getStatusCellStyle(params) {
  if (params.node.group) {
    // groupping
    return {};
  }
  const { data } = params;
  if (!data) {
    return {};
  }
  const type = getType(data);
  if (type) {
    return { fontWeight: 'bold', color: type.color };
  }
  return {};
}


function columnStatusValueGetter(params) {
  if (params.node.group) {
    // groupping
    return null;
  }
  const { data } = params;
  if (!data) {
    return null;
  }
  const type = getType(data);
  if (type) {
    return type.title;
  }
  return null;
}

function columnResultValueGetter(params) {
  if (params.node.group) {
    // groupping
    return null;
  }
  const { data } = params;
  if (!data) {
    return null;
  }

  const type = getType(data);

  if (type) {
    if (type.key === 'excluded') {
      if (data.excludedReason?.reason) {
        if (data.excludedReason.type === 'OTHER') {
          return `${data.excludedReason.label || 'OTHER'}: ${data.excludedReason.reason}`;
        }
        return data.excludedReason.reason;
      }
      return 'Unknown';
    } else if (type.key === 'submitted') {
      if (data.has_feedbacks) {
        return ProgressSummary.DICTIONARY['hasFeedbacks'] || 'Provide Feedback';
      // } else if (data.has_requests) {
        // return ProgressSummary.DICTIONARY['hasRequests'] || 'Requesting Feedback';
      } else if (data.in_outreach) {
        return ProgressSummary.DICTIONARY['inOutreach'] || 'Requesting Feedback';
      } else if (data.has_non_responsive) {
        return ProgressSummary.DICTIONARY['hasNonResponsive'] || 'No Response';
      } else if (data.hasRefused) {
        return ProgressSummary.DICTIONARY['hasRefused'] || 'Opted Out';
      } else if (data.excluded) {
        return ProgressSummary.DICTIONARY['excluded'] || 'excluded';
      } else if (data.hasBounced) {
        return ProgressSummary.DICTIONARY['hasBounced'] || 'Request Feedback Bounced';
      }
      return null;
    } else if (type.key === 'notQualified') {
      return type.title;
    } else if (type.key === 'notSubmitted') {
      const errorType = data.error?.type;
      let ek = null;

      if (errorType === 2) {
        ek = 'noQualifiedContacts';
      } else if (errorType === 3) {
        ek = 'preventedByCollectorSettings';
        // return ProgressSummary.DICTIONARY['preventedByCollectorSettings'] || 'No Qualified Contact(s)';
      } else if (errorType === 4) {
        ek = 'failedProductConditions';
      } else if (errorType === 5) {
        ek = 'invalidOwners';
      } else if (errorType === 6) {
        ek = 'invalidSenders';
      } else if (errorType === 7) {
        ek = 'invalidAccounts';
      } else {
        ek = 'others';
      }
      return ProgressSummary.DICTIONARY[ek] || ek || 'Others';
    }
    return null;
  }
  return null;
}

function getColDefs(column) {
  if (column.tag === 'reminders') {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'reminders',
      // cellRenderer: AgeRenderer,
      type: 'numericColumn',
      cellRendererParams: {
        column,
      },
    };
  } else if (column.tag === 'status') {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      enableRowGroup: true,
      valueGetter: columnStatusValueGetter,
      cellStyle: getStatusCellStyle,
      cellRendererParams: {
        column,
      },
    };
  } else if (column.tag === 'result') {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      enableRowGroup: true,
      cellClass: column.auto_height ? 'cell-wrap-text' : null,
      autoHeight: column.auto_height,
      valueGetter: columnResultValueGetter,
      cellRendererParams: {
        column,
        enableAutoHeight: true,
      },
    };
  }
  return null;
}


class RecourceTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewType: null,
    };
    this.getTableControls = this.getTableControls.bind(this);
    this.filterObjects = this.filterObjects.bind(this);
    this.onToggleViewType = this.onToggleViewType.bind(this);
    this.handleStatusCellClick = this.handleStatusCellClick.bind(this);
    this.getColDefs = this.getColDefs.bind(this);
  }



  onToggleViewType(viewType) {
    this.setState({ viewType });
  }


  filterObjects(objects) {
    const { viewType } = this.state;
    if (viewType) {
      return filter(objects, (o) => {
        return indexOf(o.categories, viewType) >= 0;
      });
    }
    return objects;
  }

  handleStatusCellClick(params) {
    this.props.onStatusCellClick(params);
  }


  getColDefs(column) {
    const col = getColDefs(column);
    if (col && column.tag === 'status') {
      return {
        ...col,
        onCellClicked: this.handleStatusCellClick,
      };
    }
    return col;
  }

  getTableControls() {
    const { viewType } = this.state;
    const { progressStats } = this.props;
    const buttons = [
      { id: null, label: 'All' },
      { id: 'submitted', label: 'Submitted' },
      { id: 'excluded', label: 'Excluded' },
      { id: 'notSubmitted', label: 'Not Submitted' },
      { id: 'notQualified', label: 'Not Qualified' },
    ];

    return (
      <ButtonGroup>
        {buttons.map((button) => {
          const stats = progressStats[button.id];
          let countComp = null;
          if (stats && stats.count) {
            countComp = (
              <span>
                <span className="badge">
                  <Counter value={stats.count}>
                    <NumberDisplay value={stats.count} precision={0} />
                  </Counter>
                </span>
                {' '}
                {button.label}
              </span>
            );
          } else if (button.id === null) {
            // all
            countComp = button.label;
          }
          if (countComp) {
            return (
              <Button key={(button.id || 'all')} active={viewType === button.id} onClick={() => { this.onToggleViewType(button.id); }}>
                {countComp}
              </Button>
            );
          }
          return null;
        })}
      </ButtonGroup>
    );
  }


  render() {
    const { isAccount, tableName } = this.props;
    const props = {
      leftControls: this.props.tableControls || this.getTableControls(),
      title: null,
      getColDefs: this.getColDefs,
      tableName,
    };
    let Cmp = OpportunityTable;

    if (isAccount) {
      props.filterAccounts = this.filterObjects;
      props.accounts = this.props.resources;
      Cmp = AccountTable;
    } else {
      props.filterOpportunities = this.filterObjects;
      props.opportunities = this.props.resources;
    }
    
    return (
      <div>
        <Cmp { ...props } />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    progressStats: getProgressStats(state),
  };
}


RecourceTable.propTypes = {
  dispatch: PropTypes.func.isRequired,
  resources: PropTypes.arrayOf(PropTypes.shape({
    opportunity_id: PropTypes.string,
    account_id: PropTypes.string,
  })).isRequired,
  isAccount: PropTypes.bool,
  tableName: PropTypes.string.isRequired,
  progressStats: PropTypes.shape({}),
  getColDefs: PropTypes.func,
  tableControls: PropTypes.node,
  onStatusCellClick: PropTypes.func,
};
RecourceTable.defaultProps = {
  loadPercentage: 0,
  progressStats: {},
  showStats: () => {},
  hasNoDecision: false,
  getColDefs: () => { return null },
  tableControls: null,
  onStatusCellClick: () => {},
};


const COMP = connect(mapStateToProps)(RecourceTable);
COMP.getColDefs = getColDefs;

export default COMP;

